var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSimpliBotIcon = function SvgSimpliBotIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    y: 0.5625,
    width: 40.875,
    height: 40.875,
    rx: 20.4375,
    fill: "white",
    stroke: "#DDE1E6",
    strokeWidth: 1.125
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12086_23415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0276 36.5552C29.6033 36.5552 36.5552 29.6033 36.5552 21.0276C36.5552 12.4519 29.6033 5.5 21.0276 5.5C12.4519 5.5 5.5 12.4519 5.5 21.0276C5.5 29.6033 12.4519 36.5552 21.0276 36.5552Z",
    fill: "url(#paint0_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0276 36.5552C29.6033 36.5552 36.5552 29.6033 36.5552 21.0276C36.5552 12.4519 29.6033 5.5 21.0276 5.5C12.4519 5.5 5.5 12.4519 5.5 21.0276C5.5 29.6033 12.4519 36.5552 21.0276 36.5552Z",
    fill: "url(#paint1_linear_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.028 35.499C29.1131 35.499 35.6673 28.9448 35.6673 20.8597C35.6673 12.7746 29.1131 6.2204 21.028 6.2204C12.9429 6.2204 6.38867 12.7746 6.38867 20.8597C6.38867 28.9448 12.9429 35.499 21.028 35.499Z",
    fill: "url(#paint2_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6739 35.499C26.8947 35.499 31.9377 30.4561 31.9377 24.2353C31.9377 18.0145 26.8947 12.9715 20.6739 12.9715C14.4531 12.9715 9.41016 18.0145 9.41016 24.2353C9.41016 30.4561 14.4531 35.499 20.6739 35.499Z",
    fill: "url(#paint3_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9834 22.0003C25.1505 25.8336 20.044 26.9417 17.5785 24.4759C15.113 22.0101 16.2212 16.9039 20.0541 13.071C23.887 9.23809 28.9932 8.12961 31.459 10.5954C33.9248 13.0612 32.8163 18.1674 28.9834 22.0003Z",
    fill: "url(#paint4_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8871 22.3724C21.4147 27.1963 15.8471 29.2809 11.4516 27.0281C7.05605 24.7752 5.4968 19.0384 7.96892 14.2145C10.441 9.39057 16.009 7.3059 20.4045 9.55878C24.8 11.8117 26.3596 17.5484 23.8871 22.3724Z",
    fill: "url(#paint5_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9084 28.9511C22.4761 31.7458 18.9847 32.8171 16.11 31.3439C13.2353 29.8706 12.066 26.411 13.4983 23.616C14.9306 20.821 18.4221 19.75 21.2968 21.2232C24.1714 22.6965 25.3407 26.1564 23.9084 28.9511Z",
    fill: "url(#paint6_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3975 32.3796C24.4886 34.6785 18.5272 32.3106 16.0825 27.0907C13.6378 21.8709 15.6355 15.7753 20.5445 13.4764C25.4534 11.1776 31.4148 13.5454 33.8595 18.7653C36.3042 23.9852 34.3065 30.0804 29.3975 32.3796Z",
    fill: "url(#paint7_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9614 13.8028C22.055 16.1546 19.5926 18.1621 16.4612 18.2868C13.3298 18.4115 10.7153 16.6063 10.6217 14.2545C10.5282 11.9027 12.9905 9.89521 16.1219 9.77047C19.2534 9.64573 21.8679 11.451 21.9614 13.8028Z",
    fill: "url(#paint8_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3351 19.589C31.6345 20.9558 28.7365 20.8695 25.8618 19.3962C22.9871 17.923 21.2247 15.6206 21.9249 14.2538C22.6252 12.8871 25.5235 12.9734 28.3982 14.4466C31.2729 15.9199 33.0356 18.2222 32.3351 19.589Z",
    fill: "url(#paint9_radial_12086_23415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51218 22.5888C6.98783 25.4304 8.50802 27.544 9.90788 27.3097C11.3077 27.0753 12.0568 24.5818 11.5812 21.7405C11.1055 18.8988 9.58532 16.7852 8.18546 17.0196C6.78591 17.2536 6.03653 19.7471 6.51218 22.5888Z",
    fill: "url(#paint10_radial_12086_23415)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5297 20.553) scale(15.5278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#007394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4718,
    stopColor: "#03637F",
    stopOpacity: 0.9106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5863,
    stopColor: "#094457",
    stopOpacity: 0.7133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6987,
    stopColor: "#0D2C37",
    stopOpacity: 0.5195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#101A20",
    stopOpacity: 0.3327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#121013",
    stopOpacity: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130C0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12086_23415",
    x1: 5.49992,
    y1: 21.0276,
    x2: 36.5553,
    y2: 21.0276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8507,
    stopColor: "#150E10",
    stopOpacity: 0.1881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8831,
    stopColor: "#1B1517",
    stopOpacity: 0.2559
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9063,
    stopColor: "#272022",
    stopOpacity: 0.3042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#373133",
    stopOpacity: 0.3433
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#4D4749",
    stopOpacity: 0.3768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#676364",
    stopOpacity: 0.4064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#878384",
    stopOpacity: 0.4332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9798,
    stopColor: "#ABA9AA",
    stopOpacity: 0.4579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9903,
    stopColor: "#D3D2D2",
    stopOpacity: 0.4798
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.028 20.8597) scale(14.6392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7902,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8696,
    stopColor: "#150E0E",
    stopOpacity: 0.2465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#1C130D",
    stopOpacity: 0.3353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9186,
    stopColor: "#271D0D",
    stopOpacity: 0.3986
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9351,
    stopColor: "#382B0C",
    stopOpacity: 0.4498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9492,
    stopColor: "#4E3D0A",
    stopOpacity: 0.4936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9617,
    stopColor: "#6A5409",
    stopOpacity: 0.5325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#8A6F07",
    stopOpacity: 0.5676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9834,
    stopColor: "#B08E05",
    stopOpacity: 0.5999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9927,
    stopColor: "#D9B002",
    stopOpacity: 0.6286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD000",
    stopOpacity: 0.6512
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6707 24.2371) rotate(-75.6289) scale(11.2635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#150D0E",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#1C0E0D",
    stopOpacity: 0.3346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    stopColor: "#27120D",
    stopOpacity: 0.3978
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#38170C",
    stopOpacity: 0.4489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8034,
    stopColor: "#4E1D0A",
    stopOpacity: 0.4927
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#6A2509",
    stopOpacity: 0.5315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8957,
    stopColor: "#8A2E07",
    stopOpacity: 0.5665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    stopColor: "#B03905",
    stopOpacity: 0.5987
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#D94402",
    stopOpacity: 0.6274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5167 17.5388) rotate(45) scale(6.3144 9.81565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD7C00",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#DF7A00",
    stopOpacity: 0.5617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7598,
    stopColor: "#E67400",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9027,
    stopColor: "#F16A00",
    stopOpacity: 0.6305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9254 18.2958) rotate(27.1376) scale(8.94333 9.81554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4881,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#150E10",
    stopOpacity: 0.2446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    stopColor: "#1B1517",
    stopOpacity: 0.3327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    stopColor: "#272022",
    stopOpacity: 0.3955
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8396,
    stopColor: "#373133",
    stopOpacity: 0.4463
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8739,
    stopColor: "#4D4749",
    stopOpacity: 0.4898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#676364",
    stopOpacity: 0.5283
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#878384",
    stopOpacity: 0.5632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#ABA9AA",
    stopOpacity: 0.5952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9793,
    stopColor: "#D3D2D2",
    stopOpacity: 0.6237
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7035 26.285) rotate(27.1376) scale(5.8487 5.68622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    stopColor: "white",
    stopOpacity: 0.8587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9648 22.9299) rotate(64.9069) scale(10.4364 9.81559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD700",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#DED500",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    stopColor: "#E3CE00",
    stopOpacity: 0.5924
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#ECC300",
    stopOpacity: 0.6193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9541,
    stopColor: "#F8B200",
    stopOpacity: 0.6408
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.291 14.0274) rotate(-2.28393) scale(5.67429 4.26156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4881,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#102639",
    stopOpacity: 0.0252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5305,
    stopColor: "#0C3F62",
    stopOpacity: 0.0538
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5557,
    stopColor: "#095688",
    stopOpacity: 0.0859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    stopColor: "#076AA8",
    stopOpacity: 0.1208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6136,
    stopColor: "#057AC4",
    stopOpacity: 0.1594
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0387DA",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#0292EB",
    stopOpacity: 0.2539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    stopColor: "#0199F6",
    stopOpacity: 0.3168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#009DFD",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9027 16.9734) rotate(27.1376) scale(5.8487 2.78101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6374,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12086_23415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.04674 22.1646) scale(4.11246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD7C00",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#DF7A00",
    stopOpacity: 0.5617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7598,
    stopColor: "#E67400",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9027,
    stopColor: "#F16A00",
    stopOpacity: 0.6305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12086_23415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    fill: "white",
    transform: "translate(5.25 5.25)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSimpliBotIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "simpliBotIcon.a55f1ea.svg";